import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-execution-case',
  templateUrl: './add-execution-case.component.html',
  styleUrls: ['./add-execution-case.component.scss']
})
export class AddExecutionCaseComponent {
  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  casesData: any[] = [];
  consumerGoodsForm!: FormGroup;
  ElecetionCasesForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });

this.inForm();
    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    switch (this.UserDetails?.roleId) {
      case 11:
        this.targetForm.addControl('blockOffice', new FormControl([Validators.required]))
        this.targetForm.controls['blockOffice'].disable();
        break;
      default:


    }


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"


    this.consumerGoodsForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: currentMonthYear, disabled: true }, Validators.required],

      urbanControlled: [0, [Validators.required, Validators.min(0)]],
      urbanUnControlled: [0, [Validators.required, Validators.min(0)]],
      ruralControlled: [0, [Validators.required, Validators.min(0)]],
      ruralUnControlled: [0, [Validators.required, Validators.min(0)]],

    });
  
    // this.GetConsumerGoods();.
    this.getTargetCount();
    this.GetYearAndMonth();
    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();


        break;
      default:
    }
    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.GetExecution();
        }
      });
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if (this.UserDetails?.roleId !== 1) {
          this.blockList = res.data.blocks;
        }

        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
          this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  inForm(){
      this.ElecetionCasesForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: false }, Validators.required],
      overDue: [0, [Validators.required, Validators.min(0)]],
      amountAsOnStart: [0, [Validators.required, Validators.min(0)]],
      reffredCases: [0, [Validators.required, Validators.min(0)]],
      reffredCasesAmount: [0, [Validators.required, Validators.min(0)]],
      decidedCases: [0, [Validators.required, Validators.min(0)]],
      decidedCasesAmount: [0, [Validators.required, Validators.min(0)]],

    });
  }
  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;



      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }


    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {

        this.blockList = res.data?.block;
        this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  GetExecution() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetExecution(obj).subscribe((res: any) => {
      if (res && res?.data && res?.data.length > 0) {
        let lastRow = res?.data[res?.data.length - 1];

        this.casesData = res?.data
        if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
          let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
          let year = (Number(lastRow?.dataMonth) <= 9) ? fyear?.split('-')[0] : fyear.split('-')[1]
          this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
          this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year;
          this.showButton = true
        } else {
          this.showButton = false
          this.casesData = []
          this.inForm();

        }


      } else {
        this.casesData = []
        this.inForm();
        this.showButton = true;
        this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
        this.currentMonth.key = '1';
        this.toastService.showInfo('NO Data Found!')
      }
    },
      (error: any) => {
      }
    );
  }
  getMonthName(month: string | number): string {
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March',
    ];
    return months[+month - 1] || 'Unknown';
  }

  getYearFromFinancialYear(financialYear: string, month: string | number): string {
    const [startYear, endYear] = financialYear.split('-');
    const monthNum = +month;
    return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
  }

  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  addData() {
    let lastItem
    if (this.casesData && this.casesData.length > 0) {
      lastItem = this.casesData[this.casesData.length - 1]
    }
    this.ElecetionCasesForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key,
      overDue: lastItem ? (lastItem.balanceAtEndNo + lastItem.casesRefNo - lastItem.casesDecidedNo) : 0,
      amountAsOnStart: lastItem ? (lastItem.overDueBeginingAmt + lastItem.casesRefAmt - lastItem.casesDecidedAmt) : 0
    });
    if (lastItem) {
      this.ElecetionCasesForm.get('overDue')?.disable();

      this.ElecetionCasesForm.get('amountAsOnStart')?.disable();


    }
    else{
       this.ElecetionCasesForm.get('overDue')?.enable();

      this.ElecetionCasesForm.get('amountAsOnStart')?.enable();
    }
  }


  onSubmit() {
    if (this.ElecetionCasesForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.ElecetionCasesForm.getRawValue();
      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.financialYear)
      let obj = {


        "blockOfficeId": payload?.blockOffice,
        "financialYear": payload?.financialYear?.financialYear?.toString(),
        "dataMonth": payload?.dataMonth,


        "overDueBeginingNo": payload?.overDue,
        "overDueBeginingAmt": payload?.amountAsOnStart,

        "casesRefNo": payload?.reffredCases,
        "casesRefAmt": payload?.reffredCasesAmount,

        "casesDecidedNo": payload?.decidedCases,
        "casesDecidedAmt": payload?.decidedCasesAmount,

        // "balanceAtEndNo":  payload?.dataMonth,
        // "balanceAtEndAmt":  payload?.dataMonth,


        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0

      }

      this.reportService.AddExecution(obj).subscribe((res: any) => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('ConsumerGoodsDistributionDataModal');
            this.ElecetionCasesForm.reset();
            this.ElecetionCasesForm.markAsUntouched();
            this.GetExecution();
            this.edit = false
            this.editId = 0;
          } else {
            this.toastService.showError(res.message);
          }

        }
        this.edit = false
      },
        (error: any) => {
        }
      );


    } else {
      this.ElecetionCasesForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }


  editRow(row: any) {

    const caseData = row;
    const headerData = this.targetForm.getRawValue();
    this.ElecetionCasesForm.patchValue({
      // financialYear: caseData.financialYear,
      financialYear: headerData.financialYear,
      blockOffice: Number(headerData?.blockOffice),
      dataMonth: caseData.dataMonth,

      overDue: caseData.overDueBeginingNo ?? 0,
      amountAsOnStart: caseData.overDueBeginingAmt ?? 0,

      reffredCases: caseData.casesRefNo ?? 0,
      reffredCasesAmount: caseData.casesRefAmt ?? 0,

      decidedCases: caseData.casesDecidedNo ?? 0,
      decidedCasesAmount: caseData.casesDecidedAmt ?? 0
    });



    this.editId = caseData?.id
    this.edit = true

    this.openModal('ConsumerGoodsDistributionDataModal');
  }
  closeModel() {
    this.ElecetionCasesForm.reset()
    this.ElecetionCasesForm.markAsUntouched()
    this.editId = 0
    this.edit = false
  }

  DeleteExecutionData(id: any) {
    this.reportService.DeleteExecutionData(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.deleteIndex = 0;
          this.toastService.showSuccess(res.message);

          // this.hideModal();
          this.GetExecution();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyExecutionData(id: any) {
    this.reportService.verifyExecutionData(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetExecution();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }
}
